'use client';

import React, { useMemo } from 'react';
import FieldRenderer from '@/components/Common/Form/fields/FieldRenderer';
import { buildDetailsField } from './feedbackFormFields';

type FeedbackDetailsStepProps = {
  error?: string;
};

const FeedbackDetailsStep = ({ error }: FeedbackDetailsStepProps) => {
  const field = useMemo(() => buildDetailsField(), []);

  return (
    <div className="it-feedback-details">
      <FieldRenderer field={field} error={error} />
    </div>
  );
};

export default FeedbackDetailsStep;
